import React, { ReactNode, useState } from 'react';
import { AdminSidebarProvider } from '../../contexts/AdminSidebarContext';
import Header, { OrdersHeaderContext } from '../Header/Header';
import BottomNavigationBar from '../BottomNavigationBar/BottomNavigationBar';
import NavigationTracker from '../NavigationTracker/NavigationTracker';
import SuperAdminSupportBanner from '../SuperAdminSupportBanner/SuperAdminSupportBanner';
import PushEnableBar from '../PushEnableBar/PushEnableBar';
import { isSupportAccessActive } from '../../utils/superAdminSupportAccess';
import { WhatsAppCallProvider } from '../../contexts/WhatsAppCallContext';
import { usePermissions } from '../../hooks/usePermissions';
import { useAssistantDock } from '../AssistantDock/assistantDockContext';
import './Layout.scss';

/**
 * Layout Component
 * Wraps pages with Header and BottomNavigationBar (mobile)
 */

interface LayoutProps {
  children: ReactNode;
  showHeader?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, showHeader = true }) => {
  const [ordersHeaderInfo, setOrdersHeaderInfo] = useState<any>(null);
  const supportMode = isSupportAccessActive();
  const { open: assistantOpen } = useAssistantDock();
  const { hasPermission, loading: permissionsLoading } = usePermissions();
  const assistantDocked = assistantOpen && !permissionsLoading && hasPermission('USE_AI');

  return (
    <AdminSidebarProvider>
      <OrdersHeaderContext.Provider value={{ ordersHeaderInfo, setOrdersHeaderInfo }}>
        <WhatsAppCallProvider>
          <div className={`layout${supportMode ? ' layout--support' : ''}${assistantDocked ? ' layout--dock' : ''}`}>
            <NavigationTracker />
            {supportMode && <SuperAdminSupportBanner />}
            {showHeader && <Header />}
            <PushEnableBar />
            <main className="layout__content">
              {children}
            </main>
            {showHeader && <BottomNavigationBar />}
          </div>
        </WhatsAppCallProvider>
      </OrdersHeaderContext.Provider>
    </AdminSidebarProvider>
  );
};

export default Layout;

